import { render, staticRenderFns } from "./rodenticide.vue?vue&type=template&id=7a006ff0&"
import script from "./rodenticide.vue?vue&type=script&lang=js&"
export * from "./rodenticide.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports